import {InternalStaticImageType} from '../../design-system/atoms/StaticImage/InternalStaticImageType.enum';
import {StaticLandingType} from '../../graphql/generated/types';
import {GnbMenuItem} from './type';

export const MENU_UID_PREFER = 10000;
export const MENU_UID_WEBTOON = 10010;
export const MENU_UID_WEBNOVEL = 10011;
export const MENU_UID_BOOK = 10016;

export const BOTTOM_LINE_STATIC_LAYOUT_TYPE_LIST: StaticLandingType[] = [
  StaticLandingType.TodayNew,
  StaticLandingType.DayOfWeek,
  StaticLandingType.Genre,
  StaticLandingType.FreeSeries,
];

export enum GnbMenuId {
  Prefer = 'Prefer',
  Webtoon = 'Webtoon',
  Webnovel = 'Webnovel',
  Book = 'Book',
  Shortcut = 'Shortcut',
  DayOfWeek = 'DayOfWeek',
}

export const GNB_MENU_LIST: GnbMenuItem[] = [
  {
    id: GnbMenuId.Prefer,
    href: '/',
    text: '추천',
    textTKey: 'mainhome_tab_recommendation',
    menuUid: MENU_UID_PREFER,
  },
  {
    id: GnbMenuId.Webtoon,
    href: `/menu/${MENU_UID_WEBTOON}`,
    text: '웹툰',
    textTKey: 'mainhome_tab_webtoon',
    menuUid: MENU_UID_WEBTOON,
  },
  {
    id: GnbMenuId.Webnovel,
    href: `/menu/${MENU_UID_WEBNOVEL}`,
    text: '웹소설',
    textTKey: 'mainhome_tab_novel',
    menuUid: MENU_UID_WEBNOVEL,
  },

  {
    id: GnbMenuId.Book,
    href: `/menu/${MENU_UID_BOOK}`,
    text: '책',
    textTKey: 'mainhome_tab_book',
    menuUid: MENU_UID_BOOK,
  },
  {
    id: GnbMenuId.DayOfWeek,
    href: '/day-of-week',
    text: '요일연재',
    textTKey: 'common_tab_ongoing',
  },
];

export const GNB_MENU_UID_MAP = GNB_MENU_LIST.reduce(
  (acc, gnbMenu) => {
    if (gnbMenu.menuUid !== undefined) {
      acc[gnbMenu.menuUid] = gnbMenu;
    }
    return acc;
  },
  {} as {[key: number]: GnbMenuItem}
);

export const SHORTCUT_ICON_MAP: {[key: string]: InternalStaticImageType} = {
  shortcut_1: InternalStaticImageType.Shortcut1,
  shortcut_2: InternalStaticImageType.Shortcut2,
  shortcut_3: InternalStaticImageType.Shortcut3,
  shortcut_4: InternalStaticImageType.Shortcut4,
  shortcut_5: InternalStaticImageType.Shortcut5,
  shortcut_6: InternalStaticImageType.Shortcut6,
  shortcut_7: InternalStaticImageType.Shortcut7,
  shortcut_8: InternalStaticImageType.Shortcut8,
  shortcut_9: InternalStaticImageType.Shortcut9,
  shortcut_10: InternalStaticImageType.Shortcut10,
  shortcut_11: InternalStaticImageType.Shortcut11,
  shortcut_12: InternalStaticImageType.Shortcut12,
  shortcut_13: InternalStaticImageType.Shortcut13,
  shortcut_14: InternalStaticImageType.Shortcut14,
  shortcut_15: InternalStaticImageType.Shortcut15,
  shortcut_16: InternalStaticImageType.Shortcut16,
  shortcut_17: InternalStaticImageType.Shortcut17,
  shortcut_18: InternalStaticImageType.Shortcut18,
  shortcut_19: InternalStaticImageType.Shortcut19,
  shortcut_20: InternalStaticImageType.Shortcut20,
  shortcut_21: InternalStaticImageType.Shortcut21,
  shortcut_22: InternalStaticImageType.Shortcut22,
  shortcut_23: InternalStaticImageType.Shortcut23,
  shortcut_24: InternalStaticImageType.Shortcut24,
  shortcut_25: InternalStaticImageType.Shortcut25,
  shortcut_26: InternalStaticImageType.Shortcut26,
  shortcut_27: InternalStaticImageType.Shortcut27,
  shortcut_28: InternalStaticImageType.Shortcut28,
  shortcut_29: InternalStaticImageType.Shortcut29,
  shortcut_30: InternalStaticImageType.Shortcut30,
  shortcut_31: InternalStaticImageType.Shortcut31,
  shortcut_32: InternalStaticImageType.Shortcut32,
  shortcut_33: InternalStaticImageType.Shortcut33,
  shortcut_34: InternalStaticImageType.Shortcut34,
  shortcut_35: InternalStaticImageType.Shortcut35,
  shortcut_36: InternalStaticImageType.Shortcut36,
  shortcut_37: InternalStaticImageType.Shortcut37,
  shortcut_38: InternalStaticImageType.Shortcut38,
};
